namespace Matrix.Administration {
    export interface RoleRow {
        RoleName?: string;
        DashboardCode?: string;
        DashboardNavigationPermission?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        Groups?: string[];
        GrantedPermissions?: string[];
        PermissionSets?: string[];
        TransitivePermissions?: string[];
    }

    export namespace RoleRow {
        export const idProperty = 'RoleName';
        export const nameProperty = 'RoleName';
        export const localTextPrefix = 'Administration.Role';
        export const lookupKey = 'Administration.Role';

        export function getLookup(): Q.Lookup<RoleRow> {
            return Q.getLookup<RoleRow>('Administration.Role');
        }
        export const deletePermission = 'Administration:Security';
        export const insertPermission = 'Administration:Security';
        export const readPermission = 'Administration:Security';
        export const updatePermission = 'Administration:Security';

        export declare const enum Fields {
            RoleName = "RoleName",
            DashboardCode = "DashboardCode",
            DashboardNavigationPermission = "DashboardNavigationPermission",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            Groups = "Groups",
            GrantedPermissions = "GrantedPermissions",
            PermissionSets = "PermissionSets",
            TransitivePermissions = "TransitivePermissions"
        }
    }
}
